export const COOKIEYES_CONSENT_COOKIE = "cookieyes-consent";

const DEFAULT_WATCH_OPTIONS = {
  category: "analytics",
  intervalMs: 250,
};

const getCookieString = (cookieString) => {
  if (typeof cookieString === "string") {
    return cookieString;
  }

  if (typeof document === "undefined") {
    return "";
  }

  return document.cookie || "";
};

export const getCookieValue = (
  cookieName,
  cookieString = getCookieString()
) => {
  const cookiePrefix = `${cookieName}=`;

  return cookieString
    .split(";")
    .map((cookie) => cookie.trim())
    .find((cookie) => cookie.startsWith(cookiePrefix))
    ?.slice(cookiePrefix.length);
};

export const parseCookieYesConsent = (
  cookieString = getCookieString()
) => {
  const encodedConsent = getCookieValue(
    COOKIEYES_CONSENT_COOKIE,
    cookieString
  );

  if (!encodedConsent) {
    return {};
  }

  return decodeURIComponent(encodedConsent)
    .split(",")
    .reduce((consent, entry) => {
      if (!entry) {
        return consent;
      }

      const [key, ...valueParts] = entry.split(":");

      if (!key || valueParts.length === 0) {
        return consent;
      }

      return {
        ...consent,
        [key]: valueParts.join(":"),
      };
    }, {});
};

export const hasCookieYesConsentFor = (
  category,
  cookieString = getCookieString()
) => parseCookieYesConsent(cookieString)[category] === "yes";

export const watchCookieYesConsent = (
  onConsentGranted,
  options = DEFAULT_WATCH_OPTIONS
) => {
  if (typeof window === "undefined") {
    return () => {};
  }

  const { category, intervalMs } = { ...DEFAULT_WATCH_OPTIONS, ...options };
  let lastConsentState = "";

  const checkConsent = () => {
    const nextConsentState = getCookieValue(COOKIEYES_CONSENT_COOKIE) || "";

    if (nextConsentState === lastConsentState) {
      return;
    }

    lastConsentState = nextConsentState;

    if (hasCookieYesConsentFor(category)) {
      onConsentGranted(parseCookieYesConsent());
    }
  };

  checkConsent();

  const intervalId = window.setInterval(checkConsent, intervalMs);

  window.addEventListener("focus", checkConsent);
  document.addEventListener("visibilitychange", checkConsent);

  return () => {
    window.clearInterval(intervalId);
    window.removeEventListener("focus", checkConsent);
    document.removeEventListener("visibilitychange", checkConsent);
  };
};
